import api from './client'

export const mercadolibreApi = {
  conexion: () => api.get('/mercadolibre/conexion'),
  guardar: (datos) => api.put('/mercadolibre/conexion', datos),
  autorizar: () => api.post('/mercadolibre/autorizar'),
  // `ean` acepta también un SKU nuestro: el backend usa su EAN.
  precios: (ean) => api.get('/mercadolibre/precios', { params: { ean } }),
  pdfUrl: (consultaId) => `/mercadolibre/consultas/${consultaId}/pdf`,
}
